import { FunctionComponent, memo } from 'react';
import { StoryCardQuoteContent } from '../../../../services';
import { IconLabel, LineClamp, getCssVar } from '../../../../shared';
import { CardContainer } from '../CardContainer';
import { RightSideStoryCardProps } from '../RightSideStoryCard';

import classes from './Social.module.scss';

export const Social: FunctionComponent<RightSideStoryCardProps> = memo(({ card }) => {
  const { content } = card;
  const { quote, quoteSource, quotePersonHandle } = content as StoryCardQuoteContent;

  return (
    <CardContainer card={card}>
      {quoteSource && (
        <div className={classes['quote-source']}>
          <IconLabel
            iconId={quoteSource.toLowerCase()}
            iconSize={14}
            color={getCssVar('--card-social-icon-color')}
            singleColor
          />
          {quotePersonHandle && (
            <span className={classes['quote-source__person']}>@{quotePersonHandle}</span>
          )}
        </div>
      )}
      {quote && (
        <LineClamp
          maxLines={3}
          readMore={'...'}
          contentClassName={classes['quote']}
          stringContent={quote}
        />
      )}
    </CardContainer>
  );
});
